import {Response, Model, ID} from '@/_metronic/helpers'
import {Brand} from '../../brands/core/_models'

export type ProductAvailability = Model & {
  supplier: ID
  name: string
  sku: string
  subjectToVat: boolean
  pricing: {
    date: Date
    currency: string
    vat: number
    discount: number
    amount: number
  }
}

export type ProductFilters = {
  types: string[]
  categories: string[]
  platforms: string[]
  statuses: string[]
  brands: Brand[]
}

export interface Thumbs {
  thumbsUp: number;
  thumbsDown: number;
}

export type Product = Model & {
  currencyRate: number
  name: string
  subtitle?: string;
  sku: string
  cover?: string
  coverFile?: File | null | undefined
  description?: string
  credits: number
  brand?: Brand
  category?: string
  plateform?: string
  faceAmount?: number
  faceCurrency?: string
  publicPricing: {
    amount: number
    currency: string
  }
  type: string
  region?: string
  stock: number
  sold: number
  threshold: number
  status: string
  path: string
  suppliers: number
  alias?: ID
  wishlisted: number;
  thumbs: Thumbs;
  meta: {
    title:string
    description:string
    keywords: Array<string>
  }
}

type Pricing = {
  supplier: string
  amount: number
}

export const computeAmount = (a: ProductAvailability, priceDigits: number) : number => {
  return parseFloat((
    parseFloat((a.pricing.amount * (100 - a.pricing.discount) / 100).toFixed(priceDigits)) /
    (1 + a.pricing.vat / 100)
  ).toFixed(4))
}

export const computeEarnings = (a: ProductAvailability, soldPrice: number, priceDigits: number) => {
  const basePrice: number = computeAmount(a, priceDigits)
  const diff = soldPrice - basePrice
  const vat = diff - (diff / (1 + a.pricing.vat / 100))

  return {
    earnings: parseFloat((diff - vat).toFixed(3)),
    vat: parseFloat(vat.toFixed(3))
  }
}

export type PricingChartData = Array<Pricing>

export type ProductsQueryResponse = Response<Array<Product>>
